// @scripts
import { SET_SESSION_DATA } from '../actions/user';
import { config } from '../config';

/**
 * @return {object} user's config
 */
export const userReducer = (
    state = config.initialState.user, action
) => {
    switch (action.type) {
        case SET_SESSION_DATA:
            return Object.assign(state, action.payload);
        default:
            return state;
    }
};
